import { faBrain, faQuestion } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { cn } from "../utils/helpers";

interface CardBackProps {
  width: number;
  height: number;
  playerName?: string;
  className?: string;
}

export function CardBack({
  width,
  height,
  playerName,
  className,
}: CardBackProps) {
  // Determine text/icon sizes based on card dimensions
  const isSmall = width < 60;
  const isMedium = width < 100;

  const iconSize = isSmall ? "text-lg" : isMedium ? "text-2xl" : "text-3xl";
  const titleSize = isSmall
    ? "text-[6px]"
    : isMedium
      ? "text-[8px]"
      : "text-xs";
  const nameSize = isSmall
    ? "text-[8px]"
    : isMedium
      ? "text-[10px]"
      : "text-sm";

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center rounded-lg shadow-lg",
        "bg-gradient-to-br from-pink-900/40 to-purple-900/40",
        "border-2 border-pink-400/50",
        className,
      )}
      style={{ width: `${width}px`, height: `${height}px` }}
    >
      {/* Player name at top (if provided) */}
      {playerName && (
        <div
          className={cn(
            "text-white/70 font-medium truncate w-full text-center px-1",
            nameSize,
          )}
        >
          {playerName}
        </div>
      )}

      {/* Brain icon */}
      <FontAwesomeIcon
        icon={faBrain}
        className={cn("text-pink-300/80 my-1", iconSize)}
      />

      {/* Game title */}
      <div className={cn("font-bold text-white/60 tracking-wider", titleSize)}>
        RESPONSUM
      </div>

      {/* Question mark icon */}
      <FontAwesomeIcon
        icon={faQuestion}
        className={cn("text-pink-300/60 my-1", iconSize)}
      />
    </div>
  );
}
